module.exports = __webpack_public_path__ + "static/media/vague.7d03aebf.png";